module.exports = __webpack_public_path__ + "img/NP.b2e482ea.svg";